var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 152.08 40.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #f37b20;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke-width: .91px;\r\n      }\r\n\r\n      .cls-2, .cls-3 {\r\n        fill: #fff;\r\n        stroke: #606161;\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: #606161;\r\n      }\r\n\r\n      .cls-3 {\r\n        opacity: .25;\r\n        stroke-width: .99px;\r\n      }\r\n\r\n      .cls-5 {\r\n        font-family: Lato-Bold, Lato;\r\n        font-size: 13.34px;\r\n        font-weight: 700;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 20.01,
    y: 4.9,
    width: 131.57,
    height: 31.12,
    rx: 15.56,
    ry: 15.56
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(47.46 25.24)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 0,
    y: 0
  }, "Lesion "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 41.2,
    y: 0
  }, "Analysis")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.45,
    y: 0.45,
    width: 40.01,
    height: 40.01,
    rx: 20,
    ry: 20
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M27.09,30.87c-.58-.01-1.47-.12-2.35-.31-1.92-.42-3.67-1.21-5.33-2.24-1.31-.81-2.49-1.77-3.64-2.79-.86-.76-1.73-1.52-2.63-2.25-1.09-.89-2.32-1.54-3.61-2.09-.75-.32-1.52-.58-2.3-.8-.25-.07-.5-.12-.75-.18-.21-.05-.38-.21-.39-.39-.01-.22.09-.42.3-.46.15-.03.32,0,.47.04.65.18,1.31.37,1.95.58,1.18.4,2.3.94,3.37,1.58.7.42,1.36.9,1.99,1.43.39.33.85.53,1.33.69.94.29,1.92.32,2.89.33.79.01,1.58.02,2.37.06,1.11.06,2.19.31,3.19.82.76.39,1.39.94,2.01,1.51.58.54,1.16,1.08,1.77,1.58.53.45,1.14.77,1.82.94.55.14,1.12.21,1.68.21.09,0,.18-.04.26-.08.66-.31,1.29-.68,1.89-1.1.08-.06.17-.12.26-.15.23-.07.42.03.53.25.08.16.03.38-.15.51-.27.2-.55.38-.83.56-.77.49-1.59.88-2.45,1.18-1.09.38-2.22.59-3.7.57ZM29.28,29.81s-.02-.05-.03-.05c-.11-.04-.22-.08-.33-.12-.81-.3-1.52-.76-2.16-1.33-.68-.61-1.35-1.24-2.03-1.85-.96-.86-2.12-1.28-3.37-1.45-.85-.12-1.71-.13-2.58-.12-.71.01-1.42,0-2.12-.1-.12-.02-.25-.02-.37-.03,0,.01-.01.02-.02.04.11.1.21.19.32.29,1.43,1.29,2.98,2.42,4.7,3.3,1.32.68,2.71,1.18,4.18,1.44,1.02.18,2.05.24,3.09.12.24-.03.47-.08.72-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M24.82,23.1c-1.51,0-2.76-.74-3.66-2.11-.45-.68-.79-1.42-1.16-2.14-.11-.23-.23-.46-.35-.68-.03-.05-.07-.11-.12-.15-1.4-1.15-2.78-2.31-4.2-3.43-1.32-1.04-2.73-1.97-4.22-2.75-1.02-.53-2.07-.97-3.17-1.28-.48-.14-.97-.24-1.45-.34-.26-.06-.45-.29-.38-.54.06-.22.26-.39.55-.33.26.05.51.1.76.16.8.19,1.57.44,2.33.74,1.5.6,2.9,1.39,4.24,2.28,1.47.98,2.85,2.08,4.21,3.21,1.04.86,2.07,1.72,3.12,2.56.86.68,1.8,1.25,2.8,1.71.71.33,1.44.59,2.21.73.75.14,1.51.2,2.27.06.62-.11,1.19-.35,1.73-.67,1.12-.66,2-1.57,2.75-2.62.12-.17.23-.34.35-.51.12-.17.33-.25.5-.19.18.07.34.24.31.48-.01.07-.04.14-.08.2-.85,1.31-1.87,2.45-3.2,3.29-.52.33-1.07.59-1.66.76-.07.02-.15.06-.21.1-.77.57-1.62.99-2.55,1.24-.51.14-1.04.21-1.72.21ZM21.29,19.41s0,.03.01.05c.28.55.58,1.08.98,1.55.62.74,1.41,1.13,2.36,1.19.66.04,1.29-.05,1.92-.25.16-.05.31-.11.47-.17,0-.02,0-.03,0-.05-2.15-.21-3.99-1.14-5.75-2.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.65,19.5c0-.29.27-.5.56-.41.37.11.73.23,1.09.36.27.1.38.33.29.58-.09.24-.33.34-.59.25-.35-.12-.69-.23-1.04-.35-.19-.06-.31-.23-.31-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.5,21.45c-.01.23-.09.37-.25.45-.17.08-.33.06-.47-.06-.13-.11-.25-.24-.38-.36-.15-.15-.31-.3-.46-.46-.24-.27-.11-.66.24-.73.14-.03.27.02.38.12.27.26.55.53.81.8.07.07.1.19.13.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.79,15.5c-.3,0-.49-.15-.52-.35-.04-.25.08-.45.32-.5.39-.09.78-.17,1.17-.24.22-.04.42.11.48.34.05.19-.06.44-.26.49-.42.11-.85.18-1.18.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.86,27.53c-.15,0-.27-.07-.35-.2-.2-.31-.4-.62-.59-.94-.14-.23-.07-.49.14-.61.22-.13.46-.07.61.15.2.31.39.61.58.93.19.31-.02.67-.39.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.24,24.26c0,.2-.11.37-.32.41-.28.06-.57.11-.85.16-.09.02-.17.03-.26.05-.28.05-.52-.11-.56-.37-.03-.24.16-.46.42-.5.36-.05.71-.13,1.07-.17.28-.04.49.16.48.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.23,20.59c0-.18,0-.37,0-.55,0-.26.19-.44.44-.44.25,0,.44.19.44.45,0,.37,0,.73,0,1.1,0,.26-.19.44-.44.44-.25,0-.43-.19-.44-.45,0,0,0-.02,0-.03,0-.17,0-.35,0-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.54,21.6c0,.15-.07.28-.21.36-.32.18-.64.36-.96.53-.2.11-.46.02-.57-.18-.11-.2-.05-.46.16-.59.31-.18.62-.36.95-.52.31-.16.64.05.64.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.78,16.2c0-.17,0-.34,0-.51.01-.27.19-.45.43-.45.25,0,.43.18.44.45,0,.25,0,.5,0,.75,0,.1,0,.2,0,.3-.02.23-.16.37-.38.41-.18.03-.37-.06-.45-.24-.03-.07-.04-.15-.04-.23,0-.16,0-.33,0-.49,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.35,16.19c.25,0,.4.13.46.34.05.17-.04.4-.21.48-.33.14-.65.28-.99.39-.26.09-.49-.05-.56-.29-.07-.21.06-.44.3-.53.29-.12.58-.24.88-.35.05-.02.11-.03.13-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.44,17.98c-.07-.02-.15-.03-.22-.07-.29-.15-.57-.31-.85-.46-.16-.09-.24-.23-.23-.41,0-.17.08-.32.24-.37.12-.04.27-.05.38,0,.31.15.61.32.91.5.18.1.25.31.19.5-.05.18-.22.3-.42.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.53,13.28c0,.22-.12.39-.28.45-.2.06-.41,0-.51-.17-.18-.32-.34-.64-.49-.98-.09-.21.02-.45.22-.54.2-.09.45-.03.56.17.17.31.32.62.48.94.02.05.02.11.02.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.72,23.62c-.15-.04-.34-.08-.54-.13-.1-.03-.19-.06-.29-.09-.23-.07-.37-.29-.32-.5.07-.26.27-.4.54-.34.27.06.54.14.8.23.19.06.3.28.27.46-.04.22-.21.37-.46.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.87,17.9c.03-.35.39-.57.66-.38.22.15.43.34.62.54.15.15.12.41-.02.56-.14.15-.39.19-.56.06-.2-.16-.39-.33-.57-.51-.07-.07-.09-.18-.13-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.36,25.03c0,.19-.13.37-.31.41-.26.05-.52.08-.77.1-.23.01-.42-.19-.43-.43,0-.23.16-.42.4-.44.21-.02.42-.05.63-.07.27-.02.49.18.49.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.09,17.35c.04-.06.08-.17.15-.26.13-.15.27-.28.42-.42.2-.19.46-.19.64-.01.18.18.17.44-.02.64-.14.14-.28.29-.43.42-.13.12-.29.16-.47.08-.18-.08-.26-.22-.28-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.73,15.12c-.15-.02-.31-.02-.46-.07-.19-.07-.29-.27-.26-.47.03-.19.2-.35.4-.36.21-.01.43-.01.64,0,.24.01.41.22.4.46,0,.23-.19.41-.42.42-.1,0-.2,0-.3,0,0,0,0,.01,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.7,15.45c-.07-.02-.14-.03-.21-.06-.17-.07-.34-.15-.51-.24-.21-.11-.3-.37-.2-.57.1-.22.35-.31.58-.21.18.08.36.16.53.25.18.09.28.3.23.48-.05.2-.22.34-.43.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.61,19.17c-.16,0-.27-.07-.36-.19-.11-.15-.22-.31-.32-.46-.14-.22-.09-.47.1-.61.19-.14.46-.1.61.1.12.16.23.32.34.48.1.15.1.31,0,.47-.08.14-.21.21-.38.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.73,19.1c-.02.15-.02.3-.07.44-.06.19-.27.3-.45.27-.22-.04-.38-.21-.38-.42,0-.19,0-.38,0-.58,0-.24.19-.42.43-.43.24,0,.43.17.45.41,0,.1,0,.2,0,.3,0,0,.01,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.47,27.54c-.06.1-.09.24-.18.3-.19.14-.4.26-.62.35-.2.09-.42-.02-.52-.21-.1-.2-.05-.43.13-.55.18-.11.36-.22.55-.3.29-.13.59.08.59.4.01,0,.02.01.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.23,22.53c0-.13.06-.25.18-.33.18-.11.36-.22.55-.3.2-.09.42,0,.53.18.11.19.09.43-.1.55-.19.13-.39.25-.61.34-.28.11-.56-.11-.56-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.97,23.45c-.14-.04-.38-.1-.61-.19-.18-.07-.26-.29-.21-.49.05-.21.22-.35.43-.32.24.04.48.1.71.19.18.07.26.3.2.52-.05.18-.2.29-.52.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.47,19.99c-.06.22-.14.49-.31.72-.13.17-.36.19-.54.08-.18-.11-.26-.34-.18-.54.06-.17.13-.34.21-.5.09-.19.3-.29.49-.24.2.05.34.22.34.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.72,25.11c-.15.01-.27-.06-.36-.18-.1-.13-.2-.26-.29-.4-.15-.22-.1-.48.09-.62.2-.14.46-.1.62.11.11.14.21.28.31.42.1.15.11.31.01.47-.08.14-.21.22-.38.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.78,25.33c-.12,0-.23-.04-.31-.15-.11-.15-.22-.29-.32-.44-.14-.22-.1-.46.1-.61.19-.14.45-.1.61.1.12.15.23.3.32.46.17.3-.04.65-.4.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.07,26.31c-.24,0-.43-.19-.44-.43,0-.25.2-.45.44-.45.24,0,.44.21.44.45,0,.24-.2.43-.44.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.57,27.21c0,.25-.2.44-.45.44-.24,0-.43-.2-.43-.44,0-.24.21-.45.44-.45.23,0,.43.21.43.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.23,28.54c0,.24-.21.45-.44.45-.24,0-.43-.21-.43-.44,0-.25.2-.44.44-.44.24,0,.43.2.43.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.93,27.43c0,.24-.2.44-.43.44-.24,0-.44-.2-.44-.44,0-.24.2-.44.43-.44.24,0,.44.2.44.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.12,28.77c.24,0,.43.2.43.44,0,.24-.21.45-.45.44-.24,0-.43-.22-.43-.47,0-.24.21-.42.45-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.59,26.76c-.25,0-.44-.19-.44-.44,0-.24.2-.44.43-.44.24,0,.45.2.45.45,0,.24-.19.43-.43.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.13,26.37c-.25,0-.44-.2-.44-.44,0-.24.2-.44.44-.44.24,0,.44.2.43.45,0,.25-.19.43-.43.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.25,28.12c0,.24-.22.43-.45.42-.24,0-.43-.22-.43-.46,0-.24.22-.43.45-.42.24,0,.44.21.43.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.95,27.2c-.25,0-.44-.19-.44-.43,0-.24.21-.45.44-.45.24,0,.43.21.43.44,0,.24-.19.43-.44.43Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.9d54b9a55b08770a10ae53bfe4a48342.svg";
export { ForwardRef as ReactComponent };